// Google Tag Manager container requested by marketing for every Mindspace
// (<space>.mindstone.com) and identity.mindstone.com. It is added alongside
// the existing trackers (RudderStack, HubSpot), not in place of them.
//
// The caller decides whether it renders at all: production only.
// eslint-disable-next-line lingui/no-unlocalized-strings -- container id, not UI copy
const GTM_ID = "GTM-MXTTZLXQ";

// Goes as high in <head> as possible.
export const GoogleTagManagerHead = () => (
  <script
    dangerouslySetInnerHTML={{
      __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`,
    }}
  />
);

// Goes immediately after the opening <body> tag.
export const GoogleTagManagerBody = () => (
  <noscript>
    <iframe
      src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
      height="0"
      width="0"
      style={{ display: "none", visibility: "hidden" }}
    />
  </noscript>
);
